import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {StatusChipComponent, StatusChipTone} from '../status-chip/status-chip.component';

/** Read-only presentation. Callers own time calculation, status and authorization. */
@Component({
  selector: 'app-time-entry',
  imports: [StatusChipComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<article>
    <header><div><h3>{{title()}}</h3>@if(subtitle()){<p>{{subtitle()}}</p>}</div><strong>{{duration()}}</strong></header>
    <div class="metadata">@if(time()){<span class="clock">{{time()}}</span>}<app-status-chip [label]="status()" [tone]="tone()" [compact]="true" /></div>
    <ng-content />
  </article>`,
  styleUrl: './time-entry.component.scss',
})
export class TimeEntryComponent {
  readonly title = input.required<string>();
  readonly subtitle = input('');
  readonly duration = input('');
  readonly time = input('');
  readonly status = input.required<string>();
  readonly tone = input<StatusChipTone>('neutral');
}
